/* WorkTrigEntityExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
//const ColumnSettingsComponent = require('./utils/column_settings/ColumnSettingsComponent');
//const LinesNumberComponent = require('./utils/lines_number/LinesNumberComponent');
const Steve = require("@gluenetworks/steve_core").getInstance();
const Registrations = require("../../../RegistrationNamespaces");
const _ = require("lodash");

class WorkTrigEntityExplorerLmrbComponent extends GameEditor {
    constructor(logger, di, editorLayout, userSession, solutionManager) {
        super(logger, di);

        this._logger = logger;
        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._solutionManager = solutionManager;
        this._openEditorFromUrl = false;
        this._filterFromUrl = false;

        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "workTriggerExplorer.viewNamespaces", []);
        let gameEditorActions = _.get(solutionDefinition, "workTriggerExplorer.actionNamespaces", []);
        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), true);

        this._registerComponentListeners();

        let superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("work-trigger-explorer-entity-lmrb");

                let otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                    this._openEditorFromUrl = { open: otherParams.openEditor || false, selectedIds: otherParams.selection };
                }
                if (!_.isEmpty(otherParams.filter) || !_.isUndefined(otherParams.filter)) {
                    this._filterFromUrl = true;
                }
            });
        };
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerComponentListeners() {
        this._solutionManager.on("activeSolutionChanged", (this._onSolutionChanged = this._onSolutionChanged.bind(this)));
        this._userSession.on("OrganizationChange", (this._onOrganizationChange = this._onOrganizationChange.bind(this)));
    }

    _unregisterComponentListeners() {
        this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    launchWorkTriggerEditor(editorState, launchOpts) {
        return this._editorLayout.launchEditor(editorState, Registrations.WORK_TRIGGER_INSTANCE_EDITOR, launchOpts);
    }

    updateFilter(filterString) {
        this.emit("UpdateFilter", filterString);
    }

    shutdown() {
        return Promise.resolve().then(
            () => {
                this._unregisterComponentListeners();
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._logger = undefined;
                this._openEditorFromUrl = undefined;
                this._filterFromUrl = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn({ error: err }, "WorkTriggerExplorerEntityLmrbComponent.shutdown() error");
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     !newActiveSolution.lmrbNamespaces ||
        //     !newActiveSolution.lmrbNamespaces.includes(
        //         Registrations.WORK_TRIGGER_EXPLORER_ENTITY_LMRB
        //     )
        // ) {
        this.shutdown();
        // }
    }

    _onOrganizationChange() {
        this.renderer.render();
    }
}

module.exports = WorkTrigEntityExplorerLmrbComponent;
WorkTrigEntityExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.solutionsManager"
];
WorkTrigEntityExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
WorkTrigEntityExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
WorkTrigEntityExplorerLmrbComponent.$iconRepoName = "worktrigger.explorer";
WorkTrigEntityExplorerLmrbComponent.$openedByDefault = true;
WorkTrigEntityExplorerLmrbComponent.$displayName = "Schedule Explorer";
